(function () {
  function mount(host) {
    if (host.shadowRoot) return;

    var template = host.querySelector('template');
    if (!template) return;
    var root = host.attachShadow({ mode: 'open' });
    root.appendChild(template.content.cloneNode(true));

    root.addEventListener('click', function (event) {
      var target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
      var offerLink = target.closest('[data-fs-return-offer]');
      if (offerLink) {
        event.preventDefault();
        var offer = document.getElementById(host.getAttribute('data-fs-offer-anchor'));
        if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var faqHeader = target.closest('.faq > .faq-header');
      if (faqHeader) faqHeader.parentElement.classList.toggle('active');
    });

    var today = new Date().toLocaleDateString('en-US', {
      weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
    });
    root.querySelectorAll('.this_day').forEach(function (element) {
      element.textContent = today;
    });

    var hours = root.querySelectorAll('.hours');
    var minutes = root.querySelectorAll('.minutes');
    var seconds = root.querySelectorAll('.seconds');
    if (hours.length) {
      function pad(number) { return String(number).padStart(2, '0'); }
      function tick() {
        var end = new Date();
        end.setHours(23, 59, 59, 999);
        var remaining = Math.max(0, Math.floor((end - new Date()) / 1000));
        hours.forEach(function (element) { element.textContent = pad(Math.floor(remaining / 3600)); });
        minutes.forEach(function (element) { element.textContent = pad(Math.floor((remaining % 3600) / 60)); });
        seconds.forEach(function (element) { element.textContent = pad(remaining % 60); });
      }
      tick();
      window.setInterval(tick, 1000);
    }

    function initSliders() {
      if (!window.Swiper) return;
      root.querySelectorAll('.swiper').forEach(function (slider) {
        if (slider.swiper) return;
        slider.className = slider.className.replace(/\bswiper-(initialized|horizontal|fade|watch-progress|backface-hidden)\b/g, '').replace(/\s+/g, ' ').trim();
        var wrapper = slider.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.removeAttribute('style');
          var slides = Array.prototype.slice.call(wrapper.querySelectorAll(':scope > .swiper-slide'));
          slides.sort(function (a, b) {
            return (parseInt(a.getAttribute('data-swiper-slide-index'), 10) || 0) -
              (parseInt(b.getAttribute('data-swiper-slide-index'), 10) || 0);
          });
          slides.forEach(function (slide) {
            slide.removeAttribute('data-swiper-slide-index');
            slide.removeAttribute('style');
            slide.className = slide.className.replace(/\bswiper-slide-(active|next|prev|visible|fully-visible)\b/g, '').replace(/\s+/g, ' ').trim();
            wrapper.appendChild(slide);
          });
        }
        new window.Swiper(slider, {
          effect: 'fade',
          fadeEffect: { crossFade: true },
          loop: true,
          speed: 600,
          autoplay: { delay: 3000, disableOnInteraction: false },
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev')
          }
        });
      });
    }

    if (window.Swiper) {
      initSliders();
    } else {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.js';
      script.onload = initSliders;
      document.head.appendChild(script);
    }
  }

  function init() {
    document.querySelectorAll('.fs-funnel-lower-host').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
